import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { BrowserRouter, Routes, Route } from "react-router-dom"; 
import Navbar from "./Components/Navbar/Navbar";
import Home from "./Components/Pages/Home";
import About from "./Components/Pages/About";
import Course from "./Components/Pages/Course";
import Services from "./Components/Pages/Services";
import Contact from "./Components/Pages/Contactus";
import Portfolio from "./Components/Pages/Portfolio";
import Internship from "./Components/Pages/Internship";
import Blog from "./Components/Pages/Blog";
import Career from "./Components/Pages/Career";
import Fullblog from "./Components/Pages/FullBlog";
import PythonFullStack from "./Components/Pages/Courses/PythonFullStack"
import JavaFullStack from "./Components/Pages/Courses/JavaFullStack"
import MernFullStack from "./Components/Pages/Courses/MernFullStack"  
import MeanFullStack from "./Components/Pages/Courses/MeanFullStack"
import MobileAppDevelopment from "./Components/Pages/Courses/MobileAppDevelopment"
import DataAnalysis from "./Components/Pages/Courses/DataAnalysis"
import UIUXDesigning from "./Components/Pages/Courses/UIUXDesigning"
import AWSCloud from "./Components/Pages/Courses/AWSCloud"
import DevOps from "./Components/Pages/Courses/DevOps"
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FcAbout } from "react-icons/fc";

function App() {
  return (
    <BrowserRouter>
      {" "}
      <div>
        <Navbar />
        <Routes>
          {" "}
          <Route path="/" element={<Home />} />
          <Route path="/about-us" element={<About />} />
          <Route path="/courses" element={<Course />} />
          <Route path="/services" element={<Services />} />
          <Route path="/contactus" element={<Contact />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/internship" element={<Internship />} />
          <Route path="/blogs" element={<Blog />} />
          <Route path="/Career" element={<Career />} />
           <Route path="/fullblog/:id" element={<Fullblog />} />
           <Route path="/pyhtonfullstack" element={<PythonFullStack />} />
           <Route path="/javafullstack" element={<JavaFullStack />} />
           <Route path="/MernFullStack" element={<MernFullStack />} />
           <Route path="/MeanFullStack" element={<MeanFullStack />} />
           <Route path="/MobileAppDevelopment" element={<MobileAppDevelopment />} />
           <Route path="/DataAnalysis" element={<DataAnalysis />} />
           <Route path="/UIUXDesigning" element={<UIUXDesigning />} />  
           <Route path="/AWSCloud" element={<AWSCloud />} />  
           <Route path="/DevOps" element={<DevOps />} />  

          {/* Add other routes as needed */}
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
